import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { usePipedriveStore } from "../..";
import useGetDealColor from "../../hooks/useGetDealColor";
import { DealStatus } from "../../interfaces/IDeal";
import styles from "./DealStatusWithIcon.module.css";

function DealStatusWithIcon({ status, stageId, className }: IDealStatusWithIconProps) {
    const getDealColor = useGetDealColor();
    const pipedriveStore = usePipedriveStore();
    const stage = useMemo(() => computed(() => pipedriveStore.dealStages.find(s => s.id === stageId)!), [stageId]).get();
    const dealColor = useMemo(() => computed(() => getDealColor(status, stage.name)), [status, stage, getDealColor]).get();

    return (
        <div className={[styles.container, className].join(" ")}>
            <div className={styles.icon} style={{ backgroundColor: dealColor }} />
            {status === DealStatus.Won ? "Won" : status === DealStatus.Lost ? "Lost" : stage.name}
        </div>
    );
}

export default observer(DealStatusWithIcon);

interface IDealStatusWithIconProps {
    status: DealStatus;
    stageId: number;
    className?: string;
}